<template>
  <div class="wrapper">
    <PersonImage
      :imageurl="testemunho?.Imagem"
      :citacao="testemunho?.Depoimento"
      :colorclass="testemunho?.Faculdade.name"/>
    <PessoaNomeFormacao
      :curso="testemunho?.Curso.nomecurto"
      :grau="testemunho?.Grau"
      :ano="testemunho?.AnoGraducao"
      :colorclass="testemunho?.Faculdade.name"
      :nome="testemunho?.Identificacao"/>
  </div>
</template>

<script>
import PersonImage from "@/components/personImage.vue";
import PessoaNomeFormacao from "@/components/PessoaNomeFormacao.vue";

export default {
  props:["testemunho"],
  components:{
    PersonImage,
    PessoaNomeFormacao
  }
}
</script>

<style scoped>
.wrapper {
  margin-right: 78px;
  margin-left: 78px;
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}

@media screen and (max-width: 1440px) {
  .wrapper{
    margin-left: 0;
    margin-right: 0;
  }
}

@media screen and (max-width: 1024px) {
  .wrapper{
    margin-left: 43px;
    margin-right: 43px;
    padding-left: 0;
    padding-right: 0;
  }
}

@media screen and (max-width: 767px) {
  .wrapper{
    margin-left: 25px;
    margin-right: 25px;
    padding-left: 0;
    padding-right: 0;
  }
}

@media screen and (max-width: 639px) {
  .wrapper{
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>